export enum SlotTab {
  morning,
  afternoon,
  evening
}
